















































































































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import Modal from '@components/Modal'
import CalendarService from '@services/CalendarService'

settings =
  name: 'AvailabilityStep'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      Modal,
    }

    data: ->
      selectedDates: []
      missingDatesModal:
        show: false
        stepName: null
      missingBoundVenuesModal:
        show: false
        stepName: null

    mounted: ->
      { calendarDateId, ...query } = @$route.query
      @$router.replace { query }
      @wizard.fetchAudienceCreative()
      @wizard.fetchCalendarDates()

    computed:
      creativeDates: -> @wizard.calendar_dates || []
      creativeDatesTableData: ->
        { formatDate } = @$options.filters
        @creativeDates.map((date) =>
          { starts_on, repeats, rrule_string: rruleString, venues_info } = date
          id: date.id
          data: date
          date: CalendarService.formatCalendarDate({ date: starts_on, repeats, rruleString })
          venuesCount: venues_info.length
          venuesInfo: @formatVenuesInfo(venues_info)
        )

      hasDates: ->
        @wizard.audienceCreativeData.stats.dates_count > 0
      hasBoundVenues: ->
        @wizard.calendar_dates?.some((date) => date.stats.venues_count > 0)
      displayConfirmModal: ->
        !@hasDates || !@hasBoundVenues

      addDateLabel: ->
        return 'Add More Dates' if @creativeDatesTableData.length
        'Add New Date'

    methods:
      hiEditDate: (date) ->
        @wizard.navToStepName 'availability-create'
        @$router.replace { query: { ...@$route.query, calendarDateId: date.id }}

      hiSetVenues: (date) ->
        @wizard.setContainerSelectorToScroll '.bind-venues-section'
        @hiEditDate date

      hiUnbindDate: (date) ->
        @wizard.unbindCalendarDatesFromAudienceCreative [date]

      hiUnbindSelectedDates: ->
        @wizard.unbindCalendarDatesFromAudienceCreative @selectedDates

      hiDatesSelectionChange: (dates) ->
        @selectedDates = dates

      hiDatesRowClick: (row) ->
        @$refs.datesTable.toggleRowSelection row

      hiDeselectAllDates: ->
        @$refs.datesTable?.clearSelection()

      hiConfirmModal: (stepName) ->
        if !@hasDates
          @missingDatesModal.show = true
          @missingDatesModal.stepName = stepName
          return

        if !@hasBoundVenues
          @missingBoundVenuesModal.show = true
          @missingBoundVenuesModal.stepName = stepName
          return

      formatVenuesInfo: (venuesInfo) ->
        limit = 20
        data = venuesInfo
        data = data[0...limit] if venuesInfo.length > limit
        data = data.map((info) => "- #{info.venue_name} - #{info.city}, #{info.state}")
        data.push "and #{venuesInfo.length - limit} more" if venuesInfo.length > limit
        data.join('<br/>')

export default VueOptions.vue settings
